import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import {
  useAsync,
  Box,
  Text,
  UnorderedList,
  Notification,
} from '@wix/cli-ui-kit';

interface RequiredApp {
  id: string;
  name: string;
}

interface MultipleAppRequirementProps {
  appId: string;
  requiredApps: RequiredApp[];
  onSubmit: (requiredApps: string[]) => void;
}

export const MultipleAppRequirement: FC<MultipleAppRequirementProps> = ({
  requiredApps,
  onSubmit,
}) => {
  const { status } = useAsync(async () => {
    onSubmit([]);
  }, []);

  return (
    <>
      {match(status, {
        Loading: () => null,
        Error: () => null,
        Success: () => {
          if (requiredApps.length === 0) {
            return null;
          }
          return (
            <Box marginBottom={1}>
              <Notification>
                <Box flexDirection="column" gap={1}>
                  <Text>
                    Please verify that the following application is installed to
                    enable use of the selected extension/plugin.
                  </Text>
                  <UnorderedList paddingLeft={2}>
                    {requiredApps.map((app) => (
                      <UnorderedList.Item key={app.id}>
                        <Text>{app.name}</Text>
                      </UnorderedList.Item>
                    ))}
                  </UnorderedList>
                </Box>
              </Notification>
            </Box>
          );
        },
      })}
    </>
  );
};
